import React from 'react'
import { ReactComponent } from './pin.svg'
import { MergeReactElementProps } from '../types'

interface PinIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', PinIconProps>

export const PinIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill='none' ref={ref} {...props} />
  }
)
